"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var hooks_1 = require("../hooks");
var reducers_1 = require("../reducers");
var getInitialForm = function () {
    return {
        form: {},
        validationStatus: {},
        messages: {},
        validations: [],
    };
};
exports.FormContext = React.createContext({ hasProvider: false });
exports.FormProvider = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var form = hooks_1.useFormContext(reducers_1.formReducer, getInitialForm(), props);
    return React.createElement(exports.FormContext.Provider, { value: form }, children);
};
